import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { graphql } from 'react-apollo';

import {
  Flex,
  Text,
  Input,
} from 'core/ui/atoms';
import { OperationHeading, OperationCard, OperationButton } from 'operations/ui/atoms';
import { CANCEL_RECURRENT_SUBSCRIPTIONS } from 'operations/api/apollo/mutations';
import { withInAppNotification } from 'core/api/toast/withInAppNotification';

@graphql(CANCEL_RECURRENT_SUBSCRIPTIONS)
@withInAppNotification
class CancelSubscriptions extends PureComponent {
  static propTypes = {
    mutate: PropTypes.func,
    showNotification: PropTypes.func,
  };

  state = {
    inProgress: false,
    _id: '',
    email: ''
  };

  setValue = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  send = async () => {
    const { _id, email } = this.state;
    if (!_id && !email) {
      return this.props.showNotification({
        title: 'Введите мейл или ID',
        message: 'Без этого никак :)',
        type: 'ERROR',
      });
    }
    const { data: { adminCancelRecurrentSubscriptions } } = await this.props.mutate({
      variables: {
        email: this.state.email,
        _id: this.state._id,
      }
    });
    if (adminCancelRecurrentSubscriptions) {
      this.setState({
        _id: '',
        email: '',
      });
      return this.props.showNotification({
        title: 'Ура!',
        message: 'Повторные списания отменены',
        type: 'SUCCESS',
      });
    } else {
      return this.props.showNotification({
        title: 'Что-то не так',
        message: 'Напишите разработчикам, опять какой-то косяк',
        type: 'ERROR',
      });
    }
  };

  render() {
    const { inProgress, _id, email } = this.state;
    return (
      <OperationCard>
        <OperationHeading>
          Отменить подписку
          <span>Отключить повторные ежемесячные списания</span>
        </OperationHeading>
        <OperationFlex>
          <Group>
            <Input
              type={'text'}
              name={'_id'}
              placeholder={'ID пользователя'}
              value={_id}
              onChange={this.setValue}
            />
            <Text>или</Text>
            <Input
              type={'text'}
              name={'email'}
              placeholder={'E-mail пользователя'}
              value={email}
              onChange={this.setValue}
            />
          </Group>
          <OperationButton disabled={inProgress} onClick={this.send}>Отменить</OperationButton>
        </OperationFlex>
      </OperationCard>
    );
  }
}

const Group = styled(Flex)`
  margin-right: 20px;
  flex-grow: 1;
  > p {
    color: ${p => p.theme.colors.gray.light};
  }
`;

const OperationFlex = styled(Flex)`
  input {
    margin: 0 5px;
    &[type="number"] {
      width: 130px;
    }
  }
`;

export default CancelSubscriptions;
